import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import './styles.scss';
import StartVideoDialog from './StartVideoDialog';
import VideoChat from './VideoChat';
import {DialogTypes, RemoteVideoState} from '../../constants/enums';


@inject('dialogStore', 'videoChatStore', 'userStore')
@observer
class VideoChatContainer extends Component {
    onCloseDialog = (event, reason) => {
        const {dialogStore, videoChatStore} = this.props;
        if (reason === 'backdropClick') {
            return;
        }
        dialogStore.closeDialog(DialogTypes.StartVideoChat);
        if (!videoChatStore.videoChatStarted && videoChatStore.remoteVideoState !== RemoteVideoState.PeerEnd) {
            videoChatStore.closeVideoChat();
        }
    }

    render() {
        const {dialogStore, userStore, isOpen, closeDialog, videoChatStore} = this.props;
        if (!userStore.isAuthenticated) {
            return null;
        }
        return (
            <Fragment>
                <VideoChat/>
                <StartVideoDialog open={dialogStore.getDialogState(DialogTypes.StartVideoChat)} onClose={this.onCloseDialog}/>
            </Fragment>
        );
    }
}

export default VideoChatContainer;
